var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var common;
        (function (common) {
            var services;
            (function (services) {
                var constantService = (function () {
                    function constantService() {
                        this.baseURI = "/api/";
                        this.apiPostURI = this.baseURI + "posts/";
                        this.apiCompanyURI = this.baseURI + "company/"; 
                        this.apiValuesURI = this.baseURI + "values/";
                        this.apiProfileURI = this.baseURI + "member/";
                    }
                    return constantService;
                })();
                services.constantService = constantService;
                angular.module("jcsfApp")
                    .service("constantService", constantService);
            })(services = common.services || (common.services = {}));
        })(common = app.common || (app.common = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
